export default __webpack_public_path__ + "static/media/stanford.9694b7bd.png";